// @flow
import {
    GET_PUSH_SERVICE_INFO,
    GET_PUSH_SERVICE_INFO_SUCCESS,
    GET_PUSH_SERVICE_INFO_FAILED,
    GET_UNREAD_NOTIFICATION,
    GET_UNREAD_NOTIFICATION_SUCCESS,
    GET_UNREAD_NOTIFICATION_FAILED,
    READ_NOTIFICATION,
    READ_NOTIFICATION_SUCCESS,
    READ_NOTIFICATION_FAILED,
} from './constants';

export const getPushServiceInfo = (): Action => ({
    type: GET_PUSH_SERVICE_INFO,
    payload: {},
});

export const getPushServiceInfoSuccess = (response): Action => ({
    type: GET_PUSH_SERVICE_INFO_SUCCESS,
    payload: response,
});

export const getPushServiceInfoFailed = (error: string): Action => ({
    type: GET_PUSH_SERVICE_INFO_FAILED,
    payload: error,
});

export const getUnreadNotification = (): Action => ({
    type: GET_UNREAD_NOTIFICATION,
    payload: {},
});

export const getUnreadNotificationSuccess = (response): Action => ({
    type: GET_UNREAD_NOTIFICATION_SUCCESS,
    payload: response,
});

export const getUnreadNotificationFailed = (error: string): Action => ({
    type: GET_UNREAD_NOTIFICATION_FAILED,
    payload: error,
});

export const readNotification = (resource_ids: []): Action => ({
    type: READ_NOTIFICATION,
    payload: resource_ids,
});

export const readNotificationSuccess = (response): Action => ({
    type: READ_NOTIFICATION_SUCCESS,
    payload: response,
});

export const readNotificationFailed = (error: string): Action => ({
    type: READ_NOTIFICATION_FAILED,
    payload: error,
});

